export class AbTestGroupDefaults {
  static CONTROL = 'control';
}

export class AbTestNames {
  // example:
  // static LOGIN_SCREEN = 'login_screen';
}
